import { useSyncExternalStore } from "react";

import { BooleanFeatureFlagKey, BooleanFeatureFlagState } from "./BooleanFeatureFlags";
import { booleanFeatureFlags } from "./firebaseBooleanFeatureFlags";

const serverSnapshot: BooleanFeatureFlagState = { enabled: false, status: "loading" };

export function useBooleanFeatureFlag(key: BooleanFeatureFlagKey): BooleanFeatureFlagState {
    return useSyncExternalStore(
        booleanFeatureFlags.subscribe,
        () => booleanFeatureFlags.getSnapshot(key),
        () => serverSnapshot
    );
}
